import { render, staticRenderFns } from "./page4.vue?vue&type=template&id=72253aa2"
import script from "./page4.vue?vue&type=script&lang=js"
export * from "./page4.vue?vue&type=script&lang=js"
import style0 from "./page4.vue?vue&type=style&index=0&id=72253aa2&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports